import Vue from 'vue';
import ToastComponent from './Toast.vue';

const ToastConstructor = Vue.extend(ToastComponent);

let instance = null;

const Toast = function (options) {
  if (!instance) {
    instance = new ToastConstructor({
      el: document.createElement('div')
    });
    document.body.appendChild(instance.$el);
  }
  
  if (typeof options === 'string') {
    instance.toast(options);
  } else if (typeof options === 'object') {
    instance.toast(options.message || '');
  }
  
  return instance;
};

Toast.install = function (Vue) {
  Vue.prototype.$toast = Toast;
};

export default Toast;
